export const ERROR_SEVERITY = 'error';
export const SUCCESS_SEVERITY = 'success';
export type SEVERITY_TYPE = 'error' | 'success';

export interface CustomSnackBarProps {
    showSnackbar: boolean,
    title?: string,
    subtitle?: string,
    duration?: number,
    severity?: SEVERITY_TYPE,
    verticalAlign?: 'bottom' | 'top',
    horizontalAlign?: "center" | "left" | "right"
};